import React from 'react';

const HomeFourFact = () => {
   return (
      <>
         <section className="fact-area fact-map green-bg pos-rel pt-115 pb-120">
            <div className="container">
               <div className="row align-items-center">
                  <div className="col-xl-10 offset-xl-1">
                     <div className="section-title pos-rel">
                        <div className="section-text section-text-white pos-rel text-center">
                           <h5 className="white-color f-400">Health Care Services</h5>
                           <h1 className="white-color mb-0">Don’t Hesitate, Contact <br/> Us For Better Help & Services.</h1>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeFourFact;